import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../core/i18n';
import { ActionButtonModule } from '../action-button';
import { DropdownModule } from '../dropdown';
import { SortDropdownComponent } from './sort-dropdown.component';

@NgModule({
  declarations: [SortDropdownComponent],
  imports: [CommonModule, ReactiveFormsModule, NzIconModule, I18nModule, DropdownModule, ActionButtonModule, NgbTooltipModule],
  exports: [SortDropdownComponent],
})
export class SortDropdownModule {}
